import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/collections/:collection/:id',
    name: 'FetchPage',
    component: () => import(/* webpackChunkName: "collections" */ '../views/FetchPage.vue')
  },
  {
    path: '/collections',
    component: () => import(/* webpackChunkName: "collections" */ '../views/FetchPage.vue')
  },
  {
    path: '/api',
    component: () => import(/* webpackChunkName: "collections" */ '../views/ApiPage.vue')
  },
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "collections" */ '../views/AboutPage.vue')
  },
  {
    path: '/privacy',
    component: () => import(/* webpackChunkName: "collections" */ '../views/PrivacyPage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  hash: false,
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return { selector: to.hash, behavior: 'smooth', }
      }
      else if (savedPosition) {
        return savedPosition;
      }
      else {
        return { x: 0, y: 0 }
      }
  }
})

export default router
